import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { S4AccessService } from './s4-access.service';
import { interval } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';
import { DOC_CONFIG } from 'src/app/doc.config';

@Component({
  selector: 'app-s4-access',
  templateUrl: './s4-access.component.html',
  styleUrls: ['./s4-access.component.scss']
})
export class S4AccessComponent implements OnInit {
  public imageSrc = 'assets/images/sombraSemFundo.png'
  public arrCalls: string[];
  public accessId: number;
  public audioChamada: string;
  public chamando = true;
  public chamar = false;
  public pausado = false;
  public acessoRealizado: boolean = false;
  public acessoSerie: any;

  public checkImage(imageSrc: string, good: { (): void; (this: GlobalEventHandlers, ev: Event): any; }, bad: OnErrorEventHandlerNonNull) {
    var img = new Image();
    img.onload = good;
    img.onerror = bad;
    img.src = imageSrc;
  }

  public checkAudio(audioSrc: string, good: { (): void; (this: GlobalEventHandlers, ev: Event): any; }, bad: OnErrorEventHandlerNonNull) {
    var audio = new Audio();
    audio.onload = good;
    audio.onerror = bad;
    audio.src = audioSrc;
  }

  public playSound(audioChamada: string) {
    audioChamada = `${DOC_CONFIG.baseUrl}/audios/` + audioChamada + ".mp3";
    const audio = new Audio(audioChamada);
    audio.muted = false;
    audio.play();
  }

  public validateCallPessoaFiltro(call, type) {
    let descricao = '';
    switch (type) {
      case 'filtroNome':
        if(call.pessoa.filtroNome && call.pessoa.filtroNome.descricao)
          descricao =  call.pessoa.filtroNome.descricao;
        break;
      case 'filtroSerie':
        if(call.pessoa.filtroSerie && call.pessoa.filtroSerie.descricao)
          descricao = call.pessoa.filtroSerie.descricao;
        break;
      case 'filtroTurma':
        if(call.pessoa.filtroTurma && call.pessoa.filtroTurma.descricao)
          descricao = call.pessoa.filtroTurma.descricao;
        break;    
      case 'filtroMatricula':
        if(call.pessoa.filtroMatricula && call.pessoa.filtroMatricula.descricao)
          descricao = call.pessoa.filtroMatricula.descricao;
        break;    
      default:
        descricao = '';
        break;
    }
    return descricao;
  }

  constructor(private accessService: S4AccessService) { }

  public ngOnInit() {
    interval(8000)
      .pipe(
        startWith(0),
        switchMap(() => this.accessService.getAccess())
      )
      .subscribe(data => {
        if (data && data.length > 0) {
          this.acessoSerie = (JSON.parse(JSON.stringify(data[0])).pessoa.filtroSerie.descricao);
          this.acessoRealizado = true;
          if (this.acessoRealizado == true) {
            if (data[0].statusSala == 0 && data[0].confirmado == 1) {
              this.pausado = false;
              this.chamando = true;
              this.arrCalls = data as string[];
              this.audioChamada = this.validateCallPessoaFiltro(
                JSON.parse(JSON.stringify(this.arrCalls[0])), 
                'filtroMatricula');
              this.accessId = parseInt(JSON.parse(JSON.stringify(this.arrCalls[0])).id);
              this.accessService.updateStatus(this.accessId);
              this.playSound(this.audioChamada);
              if (this.chamando == true) {
                this.imageSrc = `${DOC_CONFIG.baseUrl}/fotos/` + this.audioChamada + '.jpg';
              }
              setTimeout(function(){ this.chamando = false; this.pausado = true; }, 3000);
          }
        }
          this.acessoRealizado = false;
        } else {
          this.chamando = false;
          this.pausado = true;
        }
      },
        (err: HttpErrorResponse) => {
          console.log(err);
        }
      );
  }
}